module.exports = __webpack_public_path__ + "img/whatsapp-icon.f1c1a139.svg";